import { RunSummaryCard } from './RunSummaryCard';
import { StatTile } from './StatTile';
import styles from './summary.module.css';
import flakeIcon from '../icons/tiles/flake.svg';
import alwaysFailingIcon from '../icons/tiles/always-failing.svg';
import newFailuresIcon from '../icons/tiles/new-failures.svg';
import anomalyIcon from '../icons/tiles/anomaly.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HISTORY_NOTE = 'Requires run history — not available in an evidence pack.';

/** The summary strip: RunSummaryCard (left half) + four stat tiles (right).
 * Flaky is computed from the pack (count of result.flaky); the other three
 * need cross-run history a single pack cannot contain, so they show "—". */
export function SummaryStrip(_ref) {
  var run = _ref.run;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.strip,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.stripHalf,
      children: /*#__PURE__*/_jsx(RunSummaryCard, {
        run: run
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(styles.stripHalf, " ").concat(styles.tiles),
      children: [/*#__PURE__*/_jsx(StatTile, {
        title: "Flaky",
        value: run.flakyCount,
        icon: flakeIcon,
        note: run.flakyCount === null ? 'Counting flaky tests as results load…' : undefined
      }), /*#__PURE__*/_jsx(StatTile, {
        title: "Always Failing",
        value: null,
        icon: alwaysFailingIcon,
        note: HISTORY_NOTE
      }), /*#__PURE__*/_jsx(StatTile, {
        title: "New Failures",
        value: null,
        icon: newFailuresIcon,
        note: HISTORY_NOTE
      }), /*#__PURE__*/_jsx(StatTile, {
        title: "Anomalies",
        value: null,
        icon: anomalyIcon,
        note: HISTORY_NOTE
      })]
    })]
  });
}